import React from 'react'
import { Card } from 'primereact/card';
import { Button, Result } from 'antd';
const AccessDenied = () => {
  return (
    <div className="card border-light" style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}>
            <Card title="">
            <Result
    status="404"
    title="Access Denied"
    subTitle="The page your trying to access has restricted access. please contact admin"
    // extra={<Button type="primary">Back Home</Button>}
  />
            </Card>
        </div>
  )
}

export default AccessDenied